// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { RapidReviewDiagnosisResponse } from './rapid-review-diagnosis-response';

// @ts-ignore
import { RapidReviewPerformedServiceResponse } from './rapid-review-performed-service-response';

/** See com.rev360.pms.api.controller.encounter.rapidreview.RapidReviewAssessmentAndPlanResponse */
/* istanbul ignore next */
@GandalfModel
export class RapidReviewAssessmentAndPlanResponse extends GandalfModelBase {

	@GandalfProperty({ designType: Number })
	encounterId!: number;

	@GandalfArray(RapidReviewPerformedServiceResponse)
	performedServices!: RapidReviewPerformedServiceResponse[];

	@GandalfArray(RapidReviewDiagnosisResponse)
	personDiagnoses!: RapidReviewDiagnosisResponse[];

}
